module.exports = __webpack_public_path__ + "img/yes.8f497909.svg";